// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-text[data-v-3e56a206]{width:100%;color:#000}", ""]);
// Exports
module.exports = exports;
